import { axios, getNaverLoginURL, isServer } from '../../utils'
import { ZzimProducts, ZzimResponse } from '../../types/entities/api/zzim'
import hostConfig from 'common/config'
import { Error } from 'common/types/entities/error'
import HttpStatus from 'common/utils/httpStatus'
import { CurationExtensionType } from '../../constants/product/curationExtensionType'
import { StateKey } from 'common/utils/flipState'
const FETCH = '/product/zzim/FETCH'
const SET = '/product/zzim/SET'
const PUT = '/product/zzim/PUT'
const PATCH = '/product/zzim/PATCH'

const initialState: ZzimProducts = {}

export const fetchZzimProducts = (curState: StateKey, ctx, productIds: string[]) => async dispatch => {
  const headers = isServer &&
    ctx && {
      headers: {
        cookie: ctx.req.headers.cookie,
      },
    }
  const response = await axios.get<ZzimProducts>(`/v1/zzims/products/${productIds.join(',')}`, headers)

  dispatch({
    curState,
    productIds,
    zzimProducts: (response && response.data) || initialState,
    type: FETCH,
  })
}

export const setZzim = (
  curState: StateKey,
  productId: string,
  hasZzim: boolean,
  extensionType?: CurationExtensionType,
  extensionKey?: string,
) => async dispatch => {
  const pcZzimUris = hostConfig.zzimUri.pc
  const params = {
    chpid: productId,
  }

  if (extensionType) {
    params['extsCd'] = extensionType
  }

  if (extensionKey) {
    params['extsId'] = extensionKey
  }

  // TODO: 추가 파라미터 : 내용 확인 후 추가
  // if (hasZzim) {
  //   params['trCd'] = ''
  //   params['extsCd'] = ''
  //   params['extsId'] = ''
  // }

  const response = await axios.get<ZzimResponse>(hasZzim ? pcZzimUris.setProductZzim : pcZzimUris.removeProductZzim, {
    params,
    withCredentials: true,
  })

  const apiResponse: ZzimResponse = response.data

  if (!apiResponse.bSuccess) {
    if (apiResponse.sErrorCode && apiResponse.sErrorCode === 'ACCESS_DENIED') {
      const target = getNaverLoginURL()
      const error: Error = {
        target,
        status: HttpStatus.UNAUTHORIZED,
        message: apiResponse.sErrorConfirmMessage,
        detailMessage: '',
      }
      throw error
    }

    const error: Error = {
      status: HttpStatus.OK,
      message: apiResponse.htReturnValue.sMessage,
    }
    throw error
  }

  const result = {
    [productId]: {
      zzim: hasZzim,
      count: apiResponse.htReturnValue.nZzimCount || 0,
    },
  }
  dispatch({
    curState,
    type: SET,
    payload: result,
  })
}

export const putZzim = (curState: StateKey, zzimProducts: ZzimProducts) => async (dispatch, getState) => {
  const source = getState().zzimProducts[curState] || {}
  dispatch({
    curState,
    type: PUT,
    zzimProducts: {
      ...source,
      ...zzimProducts,
    },
  })
}

export const patchZzim = (curState: StateKey, productId: string, hasZzim: boolean) => async (dispatch, getState) => {
  const zzimProducts = getState().zzimProducts[curState] || {}
  zzimProducts[productId] = {
    ...zzimProducts[productId],
    zzim: hasZzim,
  }
  dispatch({
    curState,
    zzimProducts,
    type: PATCH,
  })
}

// reducers
const zzimProductsReducer = (zzimProductsState = initialState, action) => {
  switch (action.type) {
    case FETCH:
    case PUT:
    case PATCH:
      return action.zzimProducts
    case SET:
      return {
        ...zzimProductsState,
        ...action.payload,
      }
    default:
      return zzimProductsState
  }
}

export default zzimProductsReducer
